import React, { useState } from 'react';
import AddItemModal from '../inventory/AddItemModal';
import { inventoryAPI } from '../../services/inventoryAPI';

interface BulkItemCreationModalProps {
  isOpen: boolean;
  onClose: () => void;
  purchaseId: string;
  lineItemId?: string; // NEW: Optional line item ID
  purchaseDate: string;
  subcategoryId: string;
  subcategoryName: string;
  suggestedQuantity: number;
  onSave: (itemId: string) => void;
}

const BulkItemCreationModal: React.FC<BulkItemCreationModalProps> = ({
  isOpen,
  onClose,
  purchaseId,
  lineItemId, // NEW
  purchaseDate,
  subcategoryId,
  subcategoryName,
  suggestedQuantity,
  onSave
}) => {
  const [error, setError] = useState<string>('');
  
  const handleItemSave = async (itemData: any) => {
    try {
      // Actually create the item via API
      const response = await inventoryAPI.createItem(itemData);
      
      if (!response.success || !response.data) {
        setError(`Failed to create item: ${response.error?.message || 'Unknown error'}`);
        return;
      }

      // Item created successfully
      onSave(response.data.itemId);
      onClose();
    } catch (err: any) {
      setError(`Error creating item: ${err.message}`);
    }
  };

  if (!isOpen) return null;

 // Wrap AddItemModal with bulk-specific configuration
  return (
    <>
      {error && (
        <div className="fixed top-4 right-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded z-50">
          {error}
        </div>
      )}
      <AddItemModal
        isOpen={true}
        onClose={onClose}
        onSave={handleItemSave}
        purchaseId={purchaseId}
        lineItemId={lineItemId} // NEW: Pass line item ID
        suggestedCategory={subcategoryId}
        suggestedItemType="BULK_TRACKED"
        suggestedQuantity={suggestedQuantity}
        suggestedPurchaseDate={purchaseDate}
        titleOverride={`Create Bulk Item - ${subcategoryName}`}
      />
    </>
  );
};

export default BulkItemCreationModal;
